import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined'
import { AccordionDetails, Box, Button, Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import StyledAccordionContainer from '../../../../components/Accordions/StyledAccordionContainer'
import StyledAccordionSummary from '../../../../components/Accordions/StyledAccordionSummary'
import DefaultSpacingGrid from '../../../../components/Containers/DefaultSpacingGrid'
import { AccordionHeader } from '../../../../components/Headers/styles'
import { useOrderFormContext } from '../../context/OrderFormContext'
import FlowSection from '../FlowSection'
import messages from '../messages'
import EmptyContainerRequest from './EmptyContainerRequest'

interface EmptyContainerCollectionProps {
  consignmentIndex: number
  disabled?: boolean;
}

const EmptyContainerCollection: React.FC<EmptyContainerCollectionProps> = ({
  consignmentIndex,
  disabled = false,
}) => {
  const { watch, control } = useFormContext()
  const [expanded, setExpanded] = useState(true)
  const { formatMessage } = useIntl()
  const { variant } = useOrderFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `bookings.${consignmentIndex}.containerCollections`
  });

  const emptyContainerCollection = watch(
    `bookings.${consignmentIndex}.shipFrom.emptyContainerCollection`
  )

  useEffect(() => {
    if (emptyContainerCollection && fields.length === 0) {
      append({
        carrierOption: 'noPreferredLine'
      });
    }
  }, [emptyContainerCollection, fields.length, append]);

  const handleToggleAccordion = () => {
    setExpanded((prev) => !prev)
  }

  const addContainerCollection = () => {
    if (!disabled) {
      append({
        carrierOption: 'noPreferredLine'
      });
    }
  };

  if (!emptyContainerCollection) {
    return null;
  }

  return (
    <>
      <FlowSection>
        <Box sx={{
          mb: '28px'
        }}>
          <StyledAccordionContainer
            defaultExpanded
            sx={(theme: any) => ({ backgroundColor: theme.palette?.accordion?.parent?.bg, marginTop: '10px' })}
            onChange={handleToggleAccordion}
          >
            <StyledAccordionSummary
              index={`emptyContainerCollection-content-${consignmentIndex}`}
              expanded={expanded}
              title={formatMessage(messages.emptyContainerCollection)}
            >
              <AccordionHeader sx={{ flexGrow: 1 }}>
                {formatMessage(messages.emptyContainerCollection)}
              </AccordionHeader>
              {expanded && !disabled && variant !== 'summary' && (
                <Button
                  startIcon={<AddCircleOutlinedIcon />}
                  size='small'
                  onClick={(event) => {
                    event.stopPropagation();
                    addContainerCollection();
                  }}
                  sx={{ textTransform: 'none', p: 0 }}
                >
                  {formatMessage(messages.addRequest)}
                </Button>
              )}
            </StyledAccordionSummary>
            <AccordionDetails>
              <DefaultSpacingGrid container>
                {fields.map((field, index) => (
                  <Grid item xs={12} key={field.id} sx={{ mt: '10px' }}>
                    <EmptyContainerRequest
                      consignmentIndex={consignmentIndex}
                      requestIndex={index}
                      onRemove={!disabled && fields.length > 1 && variant !== 'summary' ? () => remove(index) : undefined}
                      disabled={disabled}
                    />
                  </Grid>
                ))}
              </DefaultSpacingGrid>
            </AccordionDetails>
          </StyledAccordionContainer>
        </Box>
      </FlowSection >
    </>
  )
}

export default EmptyContainerCollection
